"use client"

import type { ServiceGridListContentProps, ServiceGridListItem as ServiceGridListItemType } from "@/types/types"
import { useMemo } from "react"
import { ServiceGridListItem } from "./ServiceGridListItem"

export const ServiceGridListContent = ({ id, title, items = [], className = "" }: ServiceGridListContentProps) => {
  const validItems = useMemo(() => {
    return items.filter(item => {
      const hasImage = !!item.image && item.image.trim().length > 0
      return hasImage
    })
  }, [items])

  const hasValidItems = validItems.length > 0

  const componentId = useMemo(() => id || `service-grid-list-${Math.random().toString(36).substring(2, 9)}`, [id])

  if (!hasValidItems) {
    return null
  }

  // Kiểm tra xem item có đủ properties để bật hover effect hay không
  const shouldEnableHover = (item: ServiceGridListItemType) => {
    return !!(item.icon || item.title || item.description)
  }

  return (
    <div id={componentId} className={`w-full ${className}`}>
      <div className="mx-auto max-w-[1290px] px-4 pt-7 pb-4 sm:px-0 sm:pt-16 sm:pb-[8.6875rem]">
        {title && (
          <h2 className="text-center text-lg sm:text-2xl font-bold sm:leading-[2.3125rem] leading-[1.625rem] pb-[2.75rem] text-[#333333]">
            {title}
          </h2>
        )}

        {/* Grid layout: 2 cột trên desktop, 1 cột trên mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[2.5rem] sm:gap-5">
          {validItems.map((item, index) => (
            <ServiceGridListItem key={index} item={item} enableHover={shouldEnableHover(item)} index={index} />
          ))}
        </div>
      </div>
    </div>
  )
}
